import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as DIALOG_PAGES, L as LAST_DIALOG_TO, e as STRUCTURED_MEDIAN, M as MAX_RESPONSIVE_WIDTH } from './const.js';
import { d as defineCustomElement$e, r as removeReview, p as putReview, g as getMyReview, a as getQuestions } from './mapy-review-dialog-page-stickers2.js';
import { d as defineCustomElement$2, C as CLOSE_24 } from './mapy-icon3.js';
import { l as transDialog, m as transformMyReview, o as getPutReviewSource, q as starsToRating, v as getDetail, w as getDescriptions, x as initPOIIcons, y as poiToAlternativeItem, g as getLocale, z as classNames, A as isFirm, B as getAlternatives } from './utils2.js';
import { d as defineCustomElement$m } from './mapy-icon2.js';
import { d as defineCustomElement$l } from './mapy-loader2.js';
import { d as defineCustomElement$k } from './mapy-review-button2.js';
import { d as defineCustomElement$j } from './mapy-review-dialog-confirmation2.js';
import { d as defineCustomElement$i } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$h } from './mapy-review-dialog-page-alternatives2.js';
import { d as defineCustomElement$g } from './mapy-review-dialog-page-edit2.js';
import { d as defineCustomElement$f } from './mapy-review-dialog-page-stars-structured2.js';
import { d as defineCustomElement$d } from './mapy-review-dialog-page-text-photo2.js';
import { d as defineCustomElement$c } from './mapy-review-info-overlay2.js';
import { d as defineCustomElement$b } from './mapy-review-photo-item2.js';
import { d as defineCustomElement$a } from './mapy-review-photos-upload2.js';
import { d as defineCustomElement$9 } from './mapy-review-question2.js';
import { d as defineCustomElement$8 } from './mapy-review-stars2.js';
import { d as defineCustomElement$7 } from './mapy-review-structured-review2.js';
import { d as defineCustomElement$6 } from './mapy-review-structured-review-item2.js';
import { d as defineCustomElement$5 } from './mapy-review-textarea2.js';
import { d as defineCustomElement$4 } from './mapy-review-tooltip2.js';
import { d as defineCustomElement$3 } from './mapy-review-user2.js';

const mapyReviewDialogCss = ":host {\n\tdisplay: block;\n}\n\ndialog {\n\tborder: none;\n\tborder-radius: 12px;\n\tbackground: #ffffff;\n\tbox-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.20);\n\tbackdrop-filter: blur(14px);\n\tpadding: 0;\n\twidth: 100%;\n\tmax-width: 460px;\n\theight: 100%;\n\tmax-height: 550px;\n\toutline: none;\n\toverflow: visible;\n}\n\ndialog.edit-mode {\n\theight: fit-content;\n\tmax-height: 750px;\n\t/* chyba v safari - fit-content má 0 výšku */\n\tmin-height: 600px;\n}\n\ndialog::backdrop {\n\tbackground: rgba(0, 0, 0, 0.40);\n}\n\n/* zaviraci tlacitko */\n.close-button {\n\tpadding: 0;\n\tmargin: 0;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 12px;\n\tborder: none;\n\tbackground: transparent;\n\tcolor: #828282;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tz-index: 10;\n}\n\n.close-button mapy-icon {\n\tdisplay: block;\n}\n\n.close-button:hover,\n.close-button:focus {\n\tbackground: #f2f2f2;\n}\n\n.empty-loader-container {\n\tdisplay: flex;\n\theight: 100%;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.overlayCover {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 10;\n\tborder-radius: 12px;\n\tbackground: rgba(255, 255, 255, 0.8);\n\tuser-select: none;\n}\n\nmapy-review-dialog-confirmation {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 11;\n}\n\n.overlayText {\n\tpadding: 0;\n\tmargin: 0;\n\tfont-size: 22px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 32px; /* 145.455% */\n}\n\nmapy-review-info-overlay {\n\tz-index: 100;\n}\n\n@media only screen and (max-width: 500px) {\n\tdialog {\n\t\ttop: 16px;\n\t\tbottom: 16px;\n\t\tleft: 16px;\n\t\tright: 16px;\n\t\twidth: auto;\n\t\toverflow: hidden;\n\t\tmax-width: calc(100% - 32px);\n\t\tmax-height: calc(100% - 32px);\n\t\theight: auto;\n\n\t\t&.page-stars-structured {\n\t\t\tmax-height: 600px;\n\t\t}\n\t}\n\n\tmapy-review-dialog-page-stars-structured {\n\t\toverflow: auto;\n\t}\n}\n\n@media only screen and (max-height: 750px) {\n\tdialog.edit-mode {\n\t\theight: auto;\n\t\tmax-height: 90%;\n\t\tmin-height: auto;\n\t}\n}\n";
const MapyReviewDialogStyle0 = mapyReviewDialogCss;

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyReviewDialog_dialogRef, _MapyReviewDialog_lang, _MapyReviewDialog_dataWasLoaded, _MapyReviewDialog_isEdit, _MapyReviewDialog_editWasChanged;
defineCustomElement$2();
const MapyReviewDialog$1 = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialog extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.close = createEvent(this, "close", 1);
        this.signal = createEvent(this, "signal", 1);
        _MapyReviewDialog_dialogRef.set(this, void 0);
        _MapyReviewDialog_lang.set(this, "");
        _MapyReviewDialog_dataWasLoaded.set(this, false);
        _MapyReviewDialog_isEdit.set(this, false);
        _MapyReviewDialog_editWasChanged.set(this, false);
        this.handleCloseButton = (event) => {
            event.stopPropagation();
            this.onClose("close-button");
        };
        this.handleDialogCancel = (event) => {
            event.preventDefault();
            if (this.showCloseBtn) {
                this.onClose("esc");
            }
        };
        this.handleDialogClick = (event) => {
            // @ts-ignore
            const rect = event.target.getBoundingClientRect();
            if (rect.left > event.clientX || rect.right < event.clientX || rect.top > event.clientY || rect.bottom < event.clientY) {
                this.onClose("backdrop");
            }
        };
        this.onPageSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.afterQuestions = () => {
            this.showCloseBtn = false;
            setTimeout(() => {
                this.close.emit({
                    reason: "finished",
                });
                this.open = false;
            }, Math.max(this.dialogTimeout, 0));
        };
        this.onPageStarsStructuredSave = (event) => {
            const { rating, structuredRating } = event.detail;
            this.saveData.rating = rating;
            this.saveData.structured_rating = structuredRating;
            const putReviewData = {
                structured_rating: this.saveData.structured_rating,
            };
            this.onSave(this.getPutReviewData(putReviewData), putReviewData);
        };
        this.onPageTextPhotosSave = (event) => {
            const { media_ids, text } = event.detail;
            this.saveData.media_ids = media_ids;
            this.saveData.text = text;
            // nebyla zmena
            if (media_ids.length === 0 && !text) {
                this.closeDialogWithThankYou();
            }
            else {
                const putReviewData = {
                    structured_rating: this.saveData.structured_rating,
                    media_ids: this.saveData.media_ids,
                    text: this.saveData.text,
                };
                this.onSave(this.getPutReviewData(putReviewData), putReviewData);
            }
        };
        this.onPageEditSave = (event) => {
            const data = event.detail;
            const putReviewData = {
                rating: data.rating,
                structured_rating: data.structuredRating,
                media_ids: data.media_ids,
                text: data.text,
            };
            this.onSave(this.getPutReviewData(putReviewData), putReviewData);
        };
        this.onPageTextPhotosBack = (event) => {
            const { media_ids, text, photos } = event.detail;
            this.saveData.media_ids = media_ids;
            this.saveData.text = text;
            this.saveData.photos = photos;
            this.page = DIALOG_PAGES.STARS_STRUCTURED;
            this.signal.emit({
                name: "stars-structured-show",
                structuredItems: this.getStructuredItems(),
            });
            this.signal.emit({
                name: "back-to-page-stars-structured",
            });
        };
        this.onConfirmationClose = async () => {
            if (__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f")) {
                this.signal.emit({
                    name: "confirmation-close-edit",
                });
                this.open = false;
                this.close.emit({
                    reason: "no-edit",
                });
            }
            else {
                this.signal.emit({
                    name: "confirmation-close",
                });
                this.loading = true;
                const isPoiFirm = isFirm(this.curPoiSource);
                const removeReviewData = Object.assign({ endpoint: this.endpoint, apiKey: this.apiKey, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), review_id: this.saveData.reviewId }, isPoiFirm
                    ? {
                        // hardcodovane
                        reason: 4,
                        text: "user_revert",
                    }
                    : {});
                const removeReviewResponse = await removeReview(removeReviewData, this.debug);
                this.signal.emit({
                    name: "remove-review",
                    error: !removeReviewResponse.noError,
                    page: this.page,
                    data: removeReviewData,
                    status: removeReviewResponse.status,
                });
                if (removeReviewResponse.noError) {
                    this.loading = false;
                    this.closeDialogWithReviewRemove();
                }
                else {
                    this.loading = false;
                    this.error = transDialog(__classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), "removeReviewError");
                }
            }
        };
        this.onConfirmationCancel = () => {
            this.signal.emit({
                name: "confirmation-cancel",
            });
            this.showConfirmation = false;
        };
        this.onPhotoLoading = (event) => {
            this.photoLoading = event.detail;
        };
        this.onDataChange = (event) => {
            __classPrivateFieldSet(this, _MapyReviewDialog_editWasChanged, event.detail, "f");
        };
        this.onAlternativeSelect = async (event) => {
            const { data } = event.detail;
            const poiData = data;
            let change = false;
            this.signal.emit({
                name: "select-alternative",
                change,
                item: event.detail,
                index: this.alternativeItems.findIndex(item => item === event.detail),
            });
            if (poiData.source !== this.curPoiSource || poiData.id !== this.curPoiId) {
                this.curPoiSource = poiData.source;
                this.curPoiId = poiData.id;
                this.curPoiTitle = poiData.title || "";
                // nacteme znovu detail
                this.loading = true;
                await this.loadDetail(this.curPoiSource, this.curPoiId);
                this.loading = false;
                change = true;
            }
            this.loadStickers();
            this.processDetailData();
            if (__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f")) {
                this.page = DIALOG_PAGES.EDIT;
                this.signal.emit({
                    name: "edit-form-show",
                });
            }
            else {
                this.page = DIALOG_PAGES.STARS_STRUCTURED;
                this.signal.emit({
                    name: "stars-structured-show",
                    structuredItems: this.getStructuredItems(),
                });
            }
            this.signal.emit({
                name: "detail-load",
                data: {
                    page: this.page,
                    isEdit: __classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f"),
                },
            });
        };
        this.endpoint = "";
        this.apiKey = "";
        this.modal = true;
        this.user = "";
        this.verifiedUser = false;
        this.poiSource = "";
        this.poiId = 0;
        this.marketOfferId = 0;
        this.dialogTimeout = LAST_DIALOG_TO;
        this.debug = false;
        this.debugEdit = false;
        this.alternatives = false;
        this.switchStars = false;
        this.detailData = null;
        this.reviewData = null;
        this.service = "mapy";
        this.forceInsert = false;
        this.stickers = false;
        this.open = false;
        this.page = DIALOG_PAGES.EMPTY;
        this.saveData = transformMyReview();
        this.showConfirmation = false;
        this.loading = false;
        this.photoLoading = false;
        this.error = "";
        this.alternativeItems = [];
        this.curPoiSource = "";
        this.curPoiId = 0;
        this.curPoiTitle = "";
        this.questions = [];
        this.showCloseBtn = true;
    }
    onOpenChange(newOpen) {
        this.setDialogVisibility(newOpen);
        newOpen && this.loadData();
    }
    getStructuredItems() {
        var _a, _b;
        const items = ((_b = (_a = this.detailData) === null || _a === void 0 ? void 0 : _a.review) === null || _b === void 0 ? void 0 : _b.structured_rating)
            ? this.detailData.review.structured_rating
            : [];
        // merge s daty
        return items.map(strucItem => {
            const filtered = this.saveData.structured_rating.filter(saveItem => saveItem.key === strucItem.key);
            const rating = filtered.length === 1
                ? filtered[0].value
                : null;
            return Object.assign(Object.assign({}, strucItem), { rating });
        });
    }
    onClose(reason) {
        const isStickersAndTextPage = this.page === DIALOG_PAGES.STICKERS && this.stickers;
        if ((!__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f") && this.saveData.reviewId > 0 && reason !== "review-removed" && !isStickersAndTextPage)
            || (__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f") && __classPrivateFieldGet(this, _MapyReviewDialog_editWasChanged, "f"))) {
            this.showConfirmation = true;
            this.signal.emit({
                name: "confirmation-show",
            });
        }
        else {
            const closeEvent = this.close.emit({
                reason,
            });
            if (!closeEvent.defaultPrevented) {
                this.open = false;
            }
        }
    }
    closeDialogWithThankYou() {
        // mame stitky, je konec a jdeme na final z text/photo, musime mit otazky
        if (this.stickers && this.page === DIALOG_PAGES.TEXT_PHOTO && this.questions.length > 0) {
            this.page = DIALOG_PAGES.STICKERS;
            this.signal.emit({
                name: "show-stickers",
            });
            return;
        }
        // zavreme
        this.open = false;
        this.page = DIALOG_PAGES.THANK_YOU;
        this.signal.emit({
            name: "show-thank-you",
        });
        setTimeout(() => {
            this.page = DIALOG_PAGES.FINAL;
            this.signal.emit({
                name: "after-thank-you",
            });
            this.close.emit({
                reason: "finished",
            });
        }, Math.max(this.dialogTimeout, 0));
    }
    closeDialogWithReviewRemove() {
        // zavreme
        this.open = false;
        this.page = DIALOG_PAGES.REVIEW_REMOVE;
        this.signal.emit({
            name: "show-review-remove",
        });
        setTimeout(() => {
            this.page = DIALOG_PAGES.FINAL;
            this.signal.emit({
                name: "after-review-remove",
            });
            this.close.emit({
                reason: "review-removed",
            });
        }, Math.max(this.dialogTimeout, 0));
    }
    getPutReviewData(data) {
        return Object.assign({ endpoint: this.endpoint, apiKey: this.apiKey, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), poi_id: this.curPoiId, source: this.curPoiSource, market_offer_id: this.marketOfferId, review_source: getPutReviewSource(this.service), rating: starsToRating(this.saveData.rating) }, data);
    }
    async onSave(putReviewData, reviewData) {
        this.loading = true;
        this.error = "";
        this.signal.emit({
            name: "save-click",
            data: Object.assign({ page: this.page, rating: this.saveData.rating }, reviewData),
        });
        const putReviewResponse = await putReview(putReviewData, this.debug);
        this.signal.emit({
            name: "put-review",
            error: !putReviewResponse.noError,
            page: this.page,
            data: putReviewData,
            response: putReviewResponse.data,
            status: putReviewResponse.status,
        });
        if (putReviewResponse.noError) {
            this.loading = false;
            if (this.page === DIALOG_PAGES.STARS_STRUCTURED) {
                this.saveData.reviewId = putReviewResponse.data.review.id;
                this.page = DIALOG_PAGES.TEXT_PHOTO;
                this.signal.emit({
                    name: "text-form-show",
                });
            }
            else if (this.page === DIALOG_PAGES.TEXT_PHOTO || this.page === DIALOG_PAGES.EDIT) {
                this.closeDialogWithThankYou();
            }
        }
        else {
            this.loading = false;
            this.error = transDialog(__classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), "putReviewError");
        }
    }
    async loadDetail(source, id) {
        const detailData = await getDetail({
            endpoint: this.endpoint,
            apiKey: this.apiKey,
            source,
            id,
            lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"),
        });
        if (detailData.noError) {
            this.detailData = detailData.data.poi;
        }
        else {
            /* eslint-disable */
            console.log(detailData.error);
        }
    }
    processDetailData() {
        let reviewData = this.reviewData;
        if (this.detailData) {
            // titulek
            this.curPoiTitle = this.detailData.title;
            if (this.detailData.myReview) {
                reviewData = this.detailData.myReview;
            }
            if (this.debugEdit) {
                reviewData = getMyReview({
                    noStructuredRating: false,
                });
            }
            if (reviewData) {
                this.detailData.myReview = reviewData;
            }
        }
        __classPrivateFieldSet(this, _MapyReviewDialog_isEdit, !this.forceInsert && reviewData !== null, "f");
        // upravime data podle review dat - pro editaci
        if (reviewData) {
            this.saveData = transformMyReview(reviewData);
        }
    }
    async loadData() {
        if (__classPrivateFieldGet(this, _MapyReviewDialog_dataWasLoaded, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _MapyReviewDialog_dataWasLoaded, true, "f");
        if (!this.detailData) {
            this.loading = true;
            await this.loadDetail(this.curPoiSource, this.curPoiId);
            if (!this.detailData) {
                this.signal.emit({
                    name: "detail-load-error",
                });
            }
        }
        this.processDetailData();
        // pouzit alternativy?
        let useAlternatives = false;
        // alternativy - ale nesmi byt editace
        if (this.alternatives) {
            const alternatives = getAlternatives(this.detailData);
            const [alternativesData] = await Promise.all([
                getDescriptions({
                    endpoint: this.endpoint,
                    apiKey: this.apiKey,
                    pois: alternatives,
                    lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"),
                }),
                initPOIIcons({
                    endpoint: this.endpoint,
                    apiKey: this.apiKey,
                }),
            ]);
            if (alternativesData.error) {
                // @ts-ignore
                console.log(alternativesData.error);
                // nastavime prvni stranku
                this.page = DIALOG_PAGES.STARS_STRUCTURED;
                this.signal.emit({
                    name: "stars-structured-show",
                    structuredItems: this.getStructuredItems(),
                });
            }
            else if (alternativesData.data.poi.length) {
                useAlternatives = true;
                this.page = DIALOG_PAGES.ALTERNATIVES;
                this.alternativeItems = [
                    this.detailData,
                    ...alternativesData.data.poi,
                ].map(poi => poiToAlternativeItem(poi));
                this.signal.emit({
                    name: "show-alternatives",
                    items: this.alternativeItems,
                });
            }
        }
        if (!useAlternatives) {
            if (!__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f")) {
                this.loadStickers();
            }
            // je to nove hodnoceni, ALE uz mame nejake hvezdy A POI nevyzaduje strukturovane hodnoceni
            if (this.forceInsert && this.saveData.rating && !this.getStructuredItems().length) {
                this.page = DIALOG_PAGES.TEXT_PHOTO;
                this.signal.emit({
                    name: "text-form-show",
                });
                // jde o editaci
            }
            else if (__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f")) {
                this.page = DIALOG_PAGES.EDIT;
                this.signal.emit({
                    name: "edit-form-show",
                });
                // zaciname normalne hvezdickami/strukturkem
            }
            else {
                this.page = DIALOG_PAGES.STARS_STRUCTURED;
                this.signal.emit({
                    name: "stars-structured-show",
                    structuredItems: this.getStructuredItems(),
                });
            }
            this.signal.emit({
                name: "detail-load",
                data: {
                    page: this.page,
                    isEdit: __classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f"),
                },
            });
        }
        this.loading = false;
    }
    async loadStickers() {
        // zkusime si nacist otazky
        if (this.stickers) {
            const data = await getQuestions({
                endpoint: this.endpoint,
                apiKey: this.apiKey,
                id: this.curPoiId,
                source: this.curPoiSource,
                lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"),
            }, this.debug);
            if (data.noError) {
                this.questions = data.data.result;
            }
        }
    }
    setDialogVisibility(isOpen) {
        if (!__classPrivateFieldGet(this, _MapyReviewDialog_dialogRef, "f")) {
            return;
        }
        if (isOpen) {
            if (this.modal) {
                __classPrivateFieldGet(this, _MapyReviewDialog_dialogRef, "f").showModal();
            }
            else {
                __classPrivateFieldGet(this, _MapyReviewDialog_dialogRef, "f").show();
            }
        }
        else {
            __classPrivateFieldGet(this, _MapyReviewDialog_dialogRef, "f").close();
        }
    }
    componentDidLoad() {
        if (this.open) {
            this.onOpenChange(true);
        }
        __classPrivateFieldGet(this, _MapyReviewDialog_dialogRef, "f").focus();
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewDialog_lang, getLocale(this.hostElement), "f");
        this.curPoiSource = this.poiSource;
        this.curPoiId = this.poiId;
    }
    render() {
        var _a, _b;
        const isPoiFirm = isFirm(this.curPoiSource);
        const structuredItems = this.getStructuredItems();
        const hasButton = this.saveData.reviewId > 0 || structuredItems.length > 0;
        const structuredMedian = ((_b = (_a = this.detailData) === null || _a === void 0 ? void 0 : _a.review) === null || _b === void 0 ? void 0 : _b.target_stars)
            ? this.detailData.review.target_stars
            : STRUCTURED_MEDIAN;
        const isResponsive = window.innerWidth < MAX_RESPONSIVE_WIDTH;
        return (h(Host, { key: '948940f8afaee9078762448f1a134826bb88bcb8' }, h("dialog", { key: '8f92eb514d6df0bcc310b908c24b338b46d766eb', ref: dialog => { __classPrivateFieldSet(this, _MapyReviewDialog_dialogRef, dialog, "f"); }, onCancel: this.handleDialogCancel, onClick: this.handleDialogClick, class: classNames([__classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f") ? "edit-mode" : "", this.page.toLowerCase()]) }, this.showCloseBtn && h("button", { key: '93e52c140e12da43fd04c11f01e0ce5e4f6b1170', type: "button", class: "close-button", onClick: this.handleCloseButton }, h("mapy-icon", { key: '31bf3242ab664b94e5ed625975e4074ca7effc05', size: CLOSE_24.size }, h("path", { key: 'c2bd9bf96366c614e757c4e6ced71df714dc3a36', d: CLOSE_24.d }))), this.page === DIALOG_PAGES.EMPTY && h("div", { key: '22360524d7578024ec3671e4453f89523dd7d56d', class: "empty-loader-container" }, h("mapy-loader", { key: '6228a66114025fba5f2e70c83dea6047fc06cdb5' })), this.page === DIALOG_PAGES.EDIT && h("mapy-review-dialog-page-edit", { key: 'c6d2b39ab4b99101749d588ce6e812c4808f4c3c', lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), isFirm: isPoiFirm, onSignal: this.onPageSignal, loading: (!this.showConfirmation && this.loading) || this.photoLoading, service: this.service, switchStars: this.switchStars, onSave: this.onPageEditSave, detailData: this.detailData, user: this.user, verifiedUser: this.verifiedUser, endpoint: this.endpoint, debug: this.debug, onPhotoLoading: this.onPhotoLoading, onDataChange: this.onDataChange, isResponsive: isResponsive, apiKey: this.apiKey }), this.page === DIALOG_PAGES.ALTERNATIVES && h("mapy-review-dialog-page-alternatives", { key: '841a6c22f5538fc6b094cd9b8d7d74067968aa1b', alternatives: this.alternativeItems, onSelect: this.onAlternativeSelect, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), loading: this.loading }), this.page === DIALOG_PAGES.STARS_STRUCTURED && h("mapy-review-dialog-page-stars-structured", { key: '846ba06a3e21a5320ed2832221d357c0e2048538', user: this.user, rating: this.saveData.rating, poiTitle: this.curPoiTitle, onSignal: this.onPageSignal, hasButton: hasButton, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), loading: !this.showConfirmation && this.loading, error: this.showConfirmation ? "" : this.error, isFirm: isPoiFirm, verifiedUser: this.verifiedUser, onSave: this.onPageStarsStructuredSave, structuredItems: structuredItems, structuredMedian: structuredMedian, service: this.service, switchStars: this.switchStars, isResponsive: isResponsive }), this.page === DIALOG_PAGES.TEXT_PHOTO && h("mapy-review-dialog-page-text-photo", { key: 'fab9e5a22fefb8bd1251259cb9ac44d7fa39ef5f', rating: this.saveData.rating, onSignal: this.onPageSignal, onBack: this.onPageTextPhotosBack, isFirm: isPoiFirm, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), loading: (!this.showConfirmation && this.loading) || this.photoLoading, error: this.showConfirmation ? "" : this.error, debug: this.debug, onSave: this.onPageTextPhotosSave, onPhotoLoading: this.onPhotoLoading, text: this.saveData.text, photos: this.saveData.photos, service: this.service, endpoint: this.endpoint, isResponsive: isResponsive, apiKey: this.apiKey }), this.page === DIALOG_PAGES.STICKERS && h("mapy-review-dialog-page-stickers", { key: '24ecc2d0e989c71539839cdec01d53efb9c2247c', service: this.service, endpoint: this.endpoint, apiKey: this.apiKey, debug: this.debug, poiSource: this.curPoiSource, poiId: this.curPoiId, questions: this.questions, onSignal: this.onPageSignal, onAfterQuestions: this.afterQuestions, lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f") }), this.showConfirmation && h("mapy-review-dialog-confirmation", { key: '68e3d0300de31b28b38d09140645d99049571dd3', onClose: this.onConfirmationClose, onCancel: this.onConfirmationCancel, loading: this.loading, error: this.error !== "", lang: __classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), isEdit: __classPrivateFieldGet(this, _MapyReviewDialog_isEdit, "f") }), (this.loading || this.showConfirmation) && h("div", { key: '2768143525607a2f30ac5d2fe6822d725be4ec28', class: "overlayCover" })), this.page === DIALOG_PAGES.THANK_YOU && h("mapy-review-info-overlay", { key: 'eaedbc8cd42285b56ce1b940a63577dfc66557ad' }, h("p", { key: '11466c184f66ae88ece3d15696d8305ac231e183', class: "overlayText" }, transDialog(__classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), "thankYouResponse"))), this.page === DIALOG_PAGES.REVIEW_REMOVE && h("mapy-review-info-overlay", { key: '3bb10721c477cc1bf320ffde242ae80b5bc71518', variant: "remove" }, h("p", { key: 'a383239f84324bbf31a36daf1114cd33532887e2', class: "overlayText" }, transDialog(__classPrivateFieldGet(this, _MapyReviewDialog_lang, "f"), "afterDelete")))));
    }
    get hostElement() { return this; }
    static get watchers() { return {
        "open": ["onOpenChange"]
    }; }
    static get style() { return MapyReviewDialogStyle0; }
}, [1, "mapy-review-dialog", {
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "modal": [516],
        "user": [513],
        "verifiedUser": [516, "verified-user"],
        "poiSource": [513, "poi-source"],
        "poiId": [514, "poi-id"],
        "marketOfferId": [514, "market-offer-id"],
        "dialogTimeout": [514, "dialog-timeout"],
        "debug": [516],
        "debugEdit": [516, "debug-edit"],
        "alternatives": [516],
        "switchStars": [516, "switch-stars"],
        "detailData": [16],
        "reviewData": [16],
        "service": [513],
        "forceInsert": [516, "force-insert"],
        "stickers": [516],
        "open": [1540],
        "page": [32],
        "saveData": [32],
        "showConfirmation": [32],
        "loading": [32],
        "photoLoading": [32],
        "error": [32],
        "alternativeItems": [32],
        "curPoiSource": [32],
        "curPoiId": [32],
        "curPoiTitle": [32],
        "questions": [32],
        "showCloseBtn": [32]
    }, undefined, {
        "open": ["onOpenChange"]
    }]);
_MapyReviewDialog_dialogRef = new WeakMap(), _MapyReviewDialog_lang = new WeakMap(), _MapyReviewDialog_dataWasLoaded = new WeakMap(), _MapyReviewDialog_isEdit = new WeakMap(), _MapyReviewDialog_editWasChanged = new WeakMap();
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-confirmation", "mapy-review-dialog-footer", "mapy-review-dialog-page-alternatives", "mapy-review-dialog-page-edit", "mapy-review-dialog-page-stars-structured", "mapy-review-dialog-page-stickers", "mapy-review-dialog-page-text-photo", "mapy-review-info-overlay", "mapy-review-photo-item", "mapy-review-photos-upload", "mapy-review-question", "mapy-review-stars", "mapy-review-structured-review", "mapy-review-structured-review-item", "mapy-review-textarea", "mapy-review-tooltip", "mapy-review-user"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialog$1);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "mapy-review-dialog-confirmation":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "mapy-review-dialog-page-alternatives":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "mapy-review-dialog-page-edit":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "mapy-review-dialog-page-stars-structured":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "mapy-review-dialog-page-stickers":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "mapy-review-dialog-page-text-photo":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "mapy-review-info-overlay":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "mapy-review-photos-upload":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "mapy-review-question":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-structured-review":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-structured-review-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-user":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
    } });
}
defineCustomElement$1();

const MapyReviewDialog = MapyReviewDialog$1;
const defineCustomElement = defineCustomElement$1;

export { MapyReviewDialog, defineCustomElement };

//# sourceMappingURL=mapy-review-dialog.js.map